import { PayloadAction } from '@reduxjs/toolkit';
import { ContentReducerCreator } from '../types';

const updateContentMarkedForDeletionReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<{ id: string | number; action: 'add' | 'remove' }>) => {
    if (action.payload.action === 'add') {
      state.contentMarkedForDeletion = { ...state.contentMarkedForDeletion, [action.payload.id]: true };
    } else {
      const newObject = { ...state.contentMarkedForDeletion };
      delete newObject[action.payload.id];
      state.contentMarkedForDeletion = newObject;
    }
  });
};

export default updateContentMarkedForDeletionReducer;
